import { useRef } from 'react';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import CrisisSection from './components/CrisisSection';
import SolutionSection from './components/SolutionSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import PCCollectionSection from './components/PCCollectionSection';
import CompanySection from './components/CompanySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import MangaSection from './components/MangaSection';
import SpecialOfferBanner from './components/SpecialOfferBanner';

const HomePage: React.FC = () => {
  const ctaRef = useRef<HTMLElement | null>(null);

  const scrollToCTA = () => {
    ctaRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <main className="min-w-[360px] font-sans">
      {/* ファーストビュー */}
      <HeroSection onCTAClick={scrollToCTA} />

      {/* 期間限定特典バナー */}
      <SpecialOfferBanner onCTAClick={scrollToCTA} />

      {/* UTM導入で変わる日常（4コマ漫画） */}
      <MangaSection />

      {/* 共感・課題提起 */}
      <ProblemSection onCTAClick={scrollToCTA} />

      {/* 危機喚起・地域連動 */}
      <CrisisSection />

      {/* 解決策・UTM紹介（差別化・3層対策を含む） */}
      <SolutionSection />

      {/* ベネフィット・導入効果 */}
      <BenefitsSection />

      {/* お客様の声・実績 */}
      <TestimonialsSection />

      {/* PC引き取りサービス */}
      <PCCollectionSection />

      {/* 会社紹介・導入の流れ */}
      <CompanySection />

      {/* FAQ */}
      <FAQSection />

      {/* CTA・お問い合わせ */}
      <CTASection sectionRef={ctaRef} />
    </main>
  );
};

export default HomePage;
